import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
const API = process.env.REACT_APP_BACKEND_URL + "/api";
const V = "";
export default function AvantagesPage() {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const [moi, setMoi] = useState(null);
  const [f, setF] = useState("");
  const [open, setOpen] = useState(false);
  const [d, setD] = useState({ categorie: "Assurance" });
  const [busy, setBusy] = useState(false);
  const H = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
  const load = async () => {
    try {
      const r = await axios.get(`${API}/kpis-performance/avantages`, H());
      setRows(r.data.avantages || []); setCats(r.data.categories || []); setMoi(r.data.moi);
    } catch (e) { toast.error("Erreur de chargement"); }
  };
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!(d.titre || "").trim()) { toast.error("Le titre est obligatoire"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/kpis-performance/avantages`, d, H());
      toast.success("Avantage partage avec tous les membres");
      setOpen(false); setD({ categorie: "Assurance" }); await load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    setBusy(false);
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer cet avantage ?")) return;
    try { await axios.delete(`${API}/kpis-performance/avantages/${id}`, H()); await load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  const inp = "w-full border rounded-md h-10 px-3 text-sm";
  const list = f ? rows.filter((r) => r.categorie === f) : rows;
  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl font-bold">Avantages Collectifs</h1>
          <p className="text-sm text-gray-500">Les bons plans negocies par les membres, partages avec tout le monde.</p>
        </div>
        <button onClick={() => setOpen(!open)} className="bg-primary hover:bg-primary/90 text-white text-sm px-4 py-2 rounded-md">
          {open ? "Annuler" : "Proposer un avantage"}
        </button>
      </div>

      {open && (
        <div className="border rounded-lg p-4 bg-white space-y-3">
          <div className="grid sm:grid-cols-2 gap-3">
            <div><label className="text-xs text-gray-500">Categorie</label>
              <select className={inp} value={d.categorie} onChange={(e) => setD({ ...d, categorie: e.target.value })}>
                {cats.map((c) => (<option key={c} value={c}>{c}</option>))}
              </select></div>
            <div><label className="text-xs text-gray-500">Titre de l'avantage *</label>
              <input className={inp} value={d.titre || V} onChange={(e) => setD({ ...d, titre: e.target.value })} placeholder="-15% sur les emballages" /></div>
            <div><label className="text-xs text-gray-500">Fournisseur / enseigne</label>
              <input className={inp} value={d.fournisseur || V} onChange={(e) => setD({ ...d, fournisseur: e.target.value })} /></div>
            <div><label className="text-xs text-gray-500">Code / reference avantage</label>
              <input className={inp} value={d.code_avantage || V} onChange={(e) => setD({ ...d, code_avantage: e.target.value })} /></div>
            <div><label className="text-xs text-gray-500">Contact (nom)</label>
              <input className={inp} value={d.contact_nom || V} onChange={(e) => setD({ ...d, contact_nom: e.target.value })} /></div>
            <div><label className="text-xs text-gray-500">Telephone</label>
              <input className={inp} value={d.contact_telephone || V} onChange={(e) => setD({ ...d, contact_telephone: e.target.value })} /></div>
            <div><label className="text-xs text-gray-500">Email</label>
              <input className={inp} value={d.contact_email || V} onChange={(e) => setD({ ...d, contact_email: e.target.value })} /></div>
            <div><label className="text-xs text-gray-500">Site web</label>
              <input className={inp} value={d.site_web || V} onChange={(e) => setD({ ...d, site_web: e.target.value })} /></div>
          </div>
          <div><label className="text-xs text-gray-500">Description</label>
            <textarea className="w-full border rounded-md p-3 text-sm" rows={2} value={d.description || V} onChange={(e) => setD({ ...d, description: e.target.value })} /></div>
          <div><label className="text-xs text-gray-500">Conditions (minimum de commande, duree...)</label>
            <textarea className="w-full border rounded-md p-3 text-sm" rows={2} value={d.conditions || V} onChange={(e) => setD({ ...d, conditions: e.target.value })} /></div>
          <button onClick={save} disabled={busy} className="bg-primary hover:bg-primary/90 text-white text-sm px-4 py-2 rounded-md">
            {busy ? "Enregistrement..." : "Partager cet avantage"}
          </button>
        </div>
      )}

      <div className="flex gap-2 flex-wrap">
        <button onClick={() => setF("")} className={"text-xs px-3 py-1 rounded-full border " + (!f ? "bg-primary text-white" : "bg-white")}>Tous ({rows.length})</button>
        {cats.map((c) => {
          const n = rows.filter((r) => r.categorie === c).length;
          return (<button key={c} onClick={() => setF(c)} className={"text-xs px-3 py-1 rounded-full border " + (f === c ? "bg-primary text-white" : "bg-white")}>{c} ({n})</button>);
        })}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {list.map((a) => (
          <div key={a.id} className="border rounded-lg p-4 bg-white space-y-1">
            <div className="text-[11px] uppercase tracking-wider text-gray-400">{a.categorie}</div>
            <div className="font-semibold">{a.titre}</div>
            {a.fournisseur && <div className="text-sm text-gray-600">{a.fournisseur}</div>}
            {a.description && <p className="text-sm text-gray-700 whitespace-pre-wrap">{a.description}</p>}
            {a.conditions && <p className="text-xs text-gray-500 whitespace-pre-wrap">Conditions : {a.conditions}</p>}
            {a.code_avantage && <div className="text-sm">Code : <span className="font-mono font-semibold">{a.code_avantage}</span></div>}
            <div className="text-sm text-gray-700 pt-1">
              {a.contact_nom && <div>{a.contact_nom}</div>}
              {a.contact_telephone && <div><a href={"tel:" + a.contact_telephone} className="text-primary">{a.contact_telephone}</a></div>}
              {a.contact_email && <div><a href={"mailto:" + a.contact_email} className="text-primary break-all">{a.contact_email}</a></div>}
              {a.site_web && <div><a href={a.site_web.startsWith("http") ? a.site_web : "https://" + a.site_web} target="_blank" rel="noreferrer" className="text-primary break-all">{a.site_web}</a></div>}
            </div>
            <div className="text-xs text-gray-400 pt-2 border-t mt-2">
              Apporte par {a.apporteur_food_truck || a.apporteur_nom || "un membre"}
              {a.created_at ? " le " + String(a.created_at).slice(0, 10) : ""}
            </div>
            {moi === a.apporteur_id && (<button onClick={() => del(a.id)} className="text-xs text-red-600 underline">Supprimer</button>)}
          </div>
        ))}
        {list.length === 0 && <p className="text-sm text-gray-400">Aucun avantage pour l'instant. Soyez le premier a en proposer un.</p>}
      </div>
    </div>
  );
}
